var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.b{fill:#000000;}.a{opacity:0;}")),React.createElement("rect",{"className":"a","width":"24","height":"24","transform":"translate(0 24) rotate(-90)","key":1}),React.createElement("path",{"className":"b","d":"M10,19a1,1,0,0,1-.77-1.64L13.71,12,9.39,6.63A1.022,1.022,0,1,1,11,5.37l4.83,6a1,1,0,0,1,0,1.27l-5,6A1,1,0,0,1,10,19Z","key":2})]);
}

ArrowRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
